module.exports = __webpack_public_path__ + "img/qg-main.7bae1064.webp";